import { all, fork, SagaIterator } from './core/sagaEffects';
import { acceptAccountLinkSaga } from './acceptAccountLinkSaga';
import { acceptQuoteNotificationSaga } from './acceptQuoteNotificationSaga';
import { accountNotificationSaga } from './accountNotificationSaga';
import { acsContactTelephoneNumberSaga } from 'acscp/sagas/acsContactTelephoneNumberSaga';
import { addAccountLinkSaga } from './addAccountLinkSaga';
import { airportSearchSaga } from './airportsSearchSaga';
import { deleteAccountLinkSaga } from './deleteAccountLinkSaga';
import { fetchSaga } from './core/fetchRequestSaga';
import { flightRequestSaga } from './flightRequestSaga';
import { handleLanguageDifferencesSaga } from './handleLanguageDifferencesSaga';
import { loginAfterPasswordResetSaga } from './loginAfterPasswordResetSaga';
import { logoutSaga } from './logoutSaga';
import { markAsReadSaga } from './markAsReadSaga';
import { modificationRequestSaga } from './modificationRequestSaga';
import { notificationSaga } from './notificationSaga';
import { notificationSubscriptionSaga } from './notificationSubscriptionSaga';
import { orderSubmitSaga } from './orderSubmitSaga';
import { pdfHandlingSaga } from './pdfHandlingSaga';
import { resetStoreSaga } from './resetStoreSaga';
import { shareRefreshSaga } from './shareRefreshSaga';
import { updateSubscribedPushNotificationChannelsSaga } from './updateSubscribedPushNotificationChannelsSaga';
import { iOSPasswordSavePromptSaga } from 'acscp/sagas/iOSPasswordSavePromptSaga';

export default function* root(): SagaIterator {
    yield all([
        fork(acceptAccountLinkSaga),
        fork(acceptQuoteNotificationSaga),
        fork(accountNotificationSaga),
        fork(acsContactTelephoneNumberSaga),
        fork(addAccountLinkSaga),
        fork(airportSearchSaga),
        fork(deleteAccountLinkSaga),
        fork(fetchSaga),
        fork(flightRequestSaga),
        fork(handleLanguageDifferencesSaga),
        fork(iOSPasswordSavePromptSaga),
        fork(loginAfterPasswordResetSaga),
        fork(logoutSaga),
        fork(markAsReadSaga),
        fork(modificationRequestSaga),
        fork(notificationSaga),
        fork(notificationSubscriptionSaga),
        fork(orderSubmitSaga),
        fork(pdfHandlingSaga),
        fork(resetStoreSaga),
        fork(shareRefreshSaga),
        fork(updateSubscribedPushNotificationChannelsSaga),
    ]);
}
